import useApi from './request/useApi'
import type { AxiosError } from 'axios'
import { useCookie } from '#app'

export const getUserMe = async (): Promise<any> => {
  const { getMe } = useApi('User')
  const phiethoc_token = useCookie<string | null>('phiethoc_client')

  try {
    const res = await getMe()
    return res
  } catch (error) {
    const axiosError = error as AxiosError
    if (axiosError.response?.status === 401) {
      phiethoc_token.value = null
    }
    throw error
  }
}

export const updateUserMe = async (info: Record<string, any> = {}) => {
  const { updateProfile } = useApi()
  try {
    return await updateProfile(info)
  } catch (error) {
    throw error
  }
}
